import { render, staticRenderFns } from "./GameOfLife.vue?vue&type=template&id=b392cac2&scoped=true&"
import script from "./GameOfLife.vue?vue&type=script&lang=js&"
export * from "./GameOfLife.vue?vue&type=script&lang=js&"
import style0 from "./GameOfLife.vue?vue&type=style&index=0&id=b392cac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b392cac2",
  null
  
)

export default component.exports